// @flow
import React, { Component } from 'react'
import CoreInput from '@nrk/core-input/jsx'
import { connect } from 'react-redux'
import style from './Searchbar.css'

import { selectValue, deselectValue, handleChangeSearchValue } from '../../actions/search.js'
import { editShowingDataset } from '../../actions/dataset/dataset.js'

type Props = {
  data: Object[],
  list: Object[],
  placeholder: string,
  selectValue: Function,
  searchValue: string,
  selected: Object,
  editShowingDataset: (selected: Object | typeof undefined) => void,
  handleChangeSearchValue: (value: string) => void
}

export class SearchBar extends Component<Props, {}> {
  props: Props // <- Old API but eslint-plugin-react complains without it

  onFilter = (event: { target: { value: string } }) => {
    const { value = '' } = event.target
    this.props.handleChangeSearchValue(value)
  }

  onSelect = (e: { detail: { value: string } }) => {
    const { list, data } = this.props
    const { value } = e.detail
    const selected =
      list && list.length
        ? list.find(item => item.name === value)
        : data.find(item => item.name === value)

    this.props.editShowingDataset(selected)
  }
  render() {
    const { list, data, placeholder, searchValue } = this.props
    const suggestions = list && list.length ? list : data

    return (
      <div className={style.searchbar__container}>
        <CoreInput onFilter={this.onFilter} onSelect={this.onSelect}>
          <input
            className={style.searchbar__input}
            type="text"
            value={searchValue}
            onChange={console.log}
            placeholder={placeholder}
          />
          <ul className={style['searchbar__suggestions-container']}>
            {suggestions.map((item, key) => (
              <li key={key} className={style.searchbar__suggestion}>
                <button>
                  <CoreInput.Highlight text={item.name} query={searchValue} />
                </button>
              </li>
            ))}
          </ul>
          <div className={style.searchbarInputIcon} aria-hidden="true">
            <svg width="20" height="20" aria-hidden="true">
              <use xlinkHref="#nrk-search" />
            </svg>
          </div>
        </CoreInput>
      </div>
    )
  }
}

const mapStateToProps = ({ search, dataset }) => {
  return {
    selected: search.selected,
    searchValue: search.searchValue,
    data: dataset.rootData,
    list: search.list
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectValue: (value: Object): void => dispatch(selectValue(value)),
    deselectValue: (): void => dispatch(deselectValue()),
    editShowingDataset: (value: Object, method): void =>
      dispatch(editShowingDataset(value, method)),
    handleChangeSearchValue: (searchValue: string): void =>
      dispatch(handleChangeSearchValue(searchValue))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBar)



// WEBPACK FOOTER //
// ./src/shared/components/Searchbar/Searchbar.js